import { MDBContainer, MDBRow } from "mdb-react-ui-kit";
import React from "react";


const NoRequests = () => (
  
  <MDBContainer>
    <MDBRow>
      <div className="col-12">
        <section className="my-5 text-center">
          <h3 className="display-1">NO INVENTORY  YET</h3>

          <h4 className="mb-4">Start creating ....</h4>

         
          <p className="mb-4">
            You need to have Admin rights
          </p>
          
        </section>
      </div>
    </MDBRow>
  </MDBContainer>
 
);

export default NoRequests;
